<template>
    <div class="filter-badge-group">
        <span v-if="label" class="filter-badge-group__label">{{ label }}:</span>
        <div class="filter-badge-group__itens">
            <slot />
        </div>
    </div>
</template>

<script>
/**
 * Agrupa selos-filtro que dividem o mesmo eixo (conexão, plataforma, servidor…).
 *
 * O rótulo à esquerda existe para o eixo ficar explícito: com quatro grupos numa
 * página, "Conectados" e "Comercial" lado a lado não deixavam claro que ligar os
 * dois é uma interseção (E entre grupos), e não uma união.
 */
export default {
    name: 'FilterBadgeGroup',
    props: {
        label: { type: String, default: '' },
    },
};
</script>

<style scoped>
.filter-badge-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.filter-badge-group__label {
    font-size: 0.66rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--bdg-fg-muted);
    white-space: nowrap;
}

.filter-badge-group__itens {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}
</style>
